import { useTranslation } from 'react-i18next';

// Visual style mirrors `DefaultRoleBadge` (same shape + typography) but uses a
// neutral secondary token so users can distinguish inherited rows at a glance
// (ux.md §1.3 — `bg-gray-30 text-gray-80` is the spec-suggested resting token).
//
// `labelKey` lets the same chip render any neutral-secondary label — Wave 12
// T-051 reuses this for the manager badge (`room.manager_label`), per
// `spec/gaps/tech.md` §4.5 Option A (parameterise the existing badge).
interface InheritedRoleBadgeProps {
  labelKey?: string;
}

const InheritedRoleBadge = ({ labelKey = 'workspaces.inherited_role' }: InheritedRoleBadgeProps) => {
  const { t } = useTranslation();

  return <span className="bg-gray-30 text-gray-80 rounded-2xl px-1.5 py-0.5 text-size-xs">{t(labelKey)}</span>;
};

export default InheritedRoleBadge;
